module.exports = __webpack_public_path__ + "img/q30-4.22832322.jpg";